import React, { useCallback } from 'react';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { ComposeContextRowType } from '../../../lib/types/communication.types';
import { CONTEXT_ROW_TYPES } from './context-selector.constants';
import { getContextTypeMessages } from './context-selector.messages';
import { IContextTypeSelectProps } from './context-selector.types';

export const ContextTypeSelect: React.FC<IContextTypeSelectProps> = ({
  value,
  onChange,
  disabledTypes
}) => {
  const termLookup = useCompanySportTerminology();
  const typeMessages = getContextTypeMessages(termLookup);

  const handleChange = useCallback((event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as ComposeContextRowType);
  }, [onChange]);

  return (
    <FormControl className="context-row-type" margin="none">
      <Select
        value={value}
        onChange={handleChange}
        variant="outlined"
        margin="dense"
        inputProps={{ 'aria-label': 'Context type' }}
      >
        {CONTEXT_ROW_TYPES.map((type) => (
          <MenuItem key={type} value={type} disabled={disabledTypes.includes(type)}>
            <IntlMsg {...typeMessages[type]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
